(function(){
    'use strict'

    angular
    .module('app.eventos')
    .controller('eventos.VerInscritos', VerInscritos);

    VerInscritos.$inject = ['$animationsSrv', '$routeParams', 'ApiBaseService', 'logger'];

    function VerInscritos($animationsSrv, $routeParams, ApiBaseService, logger) {
    
        $animationsSrv.scrollToTop();

        var vm = this;

        vm.eventoId = $routeParams.eventoId ? $routeParams.eventoId : 0;
        vm.categoriaId = $routeParams.categoriaId ? $routeParams.categoriaId : 0;

        vm.collection = [];
        vm.title = 'Inscritos al Eventos';

        function getRemoteController()
        {
            return 'api/Inscripciones/All/ForUser';
        }

        getAll();

        function getAll(){
            ApiBaseService.remoteController = getRemoteController();
            var promise = ApiBaseService.getAll([vm.eventoId, vm.categoriaId]);

            promise
            .then(function(collection){
                vm.collection = collection;
            })
            .catch(function(error){
                switch (error.status) {
                    case 401:
                        logger.error('La sessión ha terminado.');
                        break;
                
                    default:
                        logger.error('Error al obtener los datos.');
                        break;
                }
            });
        };

    }
})();